const Layout = () => import('@/components/theme/Layout.vue')
const NotFound = () => import('@/components/theme/NotFound.vue')
// Lojistas
const SearchSeller = () => import('@/components/seller/SearchSeller')
const ShowSeller = () => import(/* webpackChunkName: "group-sellers" */ '@/components/seller/ShowSeller')

export const appRoutes =
{
  path: '',
  component: Layout,
  children: [
    { path: '', name: 'sellers', component: SearchSeller },
    { path: ':sellerId/detalhes', name: 'show-seller', component: ShowSeller },
    { path: '**', component: NotFound }
  ]
}



// WEBPACK FOOTER //
// ./src/router/module.router.js